<script lang="ts">
	import { format } from 'svelte-i18n';
	import { user_settings } from 'src/stores/account/user';
	import { Button, Alert, Modal, Text, Container } from '@Shelly/shelly-design-system';
	import WeatherLocationModal from '../../Weather/WeatherLocationModal.svelte';
	import { saveWeatherStation } from 'src/helpers/geolocalion_helper';
	import type { WeatherStationSaveData } from 'src/types/requests/services/weather';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';

	let showWeatherLocationModal = false,
		showDeleteWeatherModal = false;
	const deleteWeatherStation = async () => {
		const weatherData: WeatherStationSaveData = $user_settings?.weather_station?.data;
		if (weatherData) {
			weatherData.stationName = null;
			const res = await saveWeatherStation(weatherData);
			if (res?.isok) {
				showDeleteWeatherModal = false;
			} else {
				onSettingsResponse(res);
			}
		}
	};
</script>

<div class="d-flex align-items-center flex-wrap width-full gap-s">
	{#if $user_settings?.weather_station?.data?.stationName}
		<Alert
			class="width-full"
			customIcon="fa-solid fa-location-check text-success"
			type="success"
			heading={$format('current_weather_station', {
				default: 'Current Weather Station:',
			})}
			subHeading={$user_settings?.weather_station?.data?.stationName}
			isHeadingBold
		/>
	{/if}
	<Button
		class="width-md-auto width-sm-full text-nowrap"
		size="m"
		on:click={() => (showWeatherLocationModal = true)}
	>
		{$format('edit_weather_location', { default: 'Edit Weather Location' })}
	</Button>

	<Button
		variant="danger"
		disabled={!$user_settings?.weather_station?.data?.stationName}
		class="width-md-auto width-sm-full text-nowrap"
		size="m"
		on:click={() => (showDeleteWeatherModal = true)}
	>
		{$format('delete_weather_location', {
			default: 'Delete Weather Location',
		})}
	</Button>
</div>
{#if showWeatherLocationModal}
	<WeatherLocationModal bind:showModal={showWeatherLocationModal} />
{/if}
<Modal
	showModal={showDeleteWeatherModal}
	on:close={() => (showDeleteWeatherModal = false)}
	title={`${$format('button_delete', { default: 'Delete' })} ${$format('weather_location')}?`}
>
	<Container slot="content" padding="0">
		<Text>
			{$format('delete_weather_location_msg', {
				default:
					'Deleting the weather location will reset the weather widget to its initial state.',
			})}
		</Text>
		<Alert
			class="mt-m"
			type="warning"
			heading={$format('weather_forecast_deleted_alert', {
				default: 'Please note that any weather forecast based scenes will no longer work.',
			})}
		/>
	</Container>

	<div class="d-flex justify-content-end" slot="footer">
		<Button
			class="width-md-m width-sm-full mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={() => (showDeleteWeatherModal = false)}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="width-md-m width-sm-full"
			variant="danger"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={deleteWeatherStation}
		>
			{$format('button_delete', { default: 'Delete' })}
			{$format('label_location', { default: 'location' }).toLowerCase()}
		</Button>
	</div>
</Modal>
